import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {
  AiDashboardWidgetType,
  DashboardWidgetType,
} from 'common/src/modules/dashboards/dashboards.types';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';
import _find from 'lodash/find';
import _flatten from 'lodash/flatten';
import _map from 'lodash/map';
import {DimensionValue} from '../../../../analytics.types';
import getRemoteDimensionKey from '../../../../utils/getRemoteDimensionKey';
import {copilotAnalyticsWidgetSchema} from '../../../copilotAnalytics.schemas';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';

function checkWidgetExistsTool(store: CLStore) {
  async function execute({
    input: {dimension: aiDimension, metrics, breakdownByTime, type},
  }: ToolExecuteParams<typeof copilotAnalyticsWidgetSchema>): Promise<ToolResult> {
    const {
      campaignPage: {
        insightsPage: {availableDimensions, dashboards},
      },
    } = store.getState();

    const widgetType = getMatchingEnumValue(AiDashboardWidgetType, DashboardWidgetType, type);

    const dimension =
      getRemoteDimensionKey<DimensionValue>(availableDimensions, aiDimension) ??
      DimensionValue.Date;

    const widgets = await Promise.all(_map(dashboards, ({id}) => dashboardsApi.getWidgets(id)));

    const existingWidget = _find(_flatten(widgets), {
      dimensions: [dimension],
      metrics,
      type: widgetType,
      breakdownByTime,
    });

    const isSkillsMode = isFlagEnabled(FeatureFlagKey.EnableCopilotSkills);

    if (isSkillsMode) {
      return toolResult(JSON.stringify(!!existingWidget));
    }

    const result = existingWidget ? 'exists' : 'does not exist';

    return toolResult(`Inline-widget ${result}`);
  }

  return tool({
    name: CampaignAnalyticsToolName.CheckWidgetExists,
    displayName: 'Checking if widget exists',
    description: 'check if a dashboard widget with the specific properties already exists',
    execute,
    inputSchema: copilotAnalyticsWidgetSchema,
  });
}

export default checkWidgetExistsTool;
